module.exports = __webpack_public_path__ + "img/allinpadel-logo.f9e50b03.png";